import React, { memo } from 'react';
export function ProblemSection() {
  const problems = ['😴 Te acuestas agotado pero tu mente no para', '🔁 Te despiertas a las 3am sin razón aparente', '☀️ Amaneces más cansado que cuando te acostaste', '☕ Necesitas café urgente para funcionar en la mañana', '🧠 Tu concentración y memoria fallan durante el día', '😰 El estrés del día te sigue en la cama de noche'];
  return <section className="bg-light-navy py-20" data-id="element-150">
      <div className="max-w-6xl mx-auto px-4" data-id="element-151">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary text-center mb-12" data-id="element-152">
          ¿Reconoces alguna de estas situaciones?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-153">
          {problems.map((problem, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center" data-id="element-154">
              <p className="text-text font-medium text-lg leading-snug" data-id="element-155">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-center text-primary font-bold text-xl md:text-2xl" data-id="element-156">
          Si reconociste 2 o más...
          <br className="md:hidden" data-id="element-157" /> tu ritmo circadiano está alterado.
        </p>
      </div>
    </section>;
}